function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAutopay = function SvgAutopay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: props.fill,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m2 13.59 2.684-2.696 2.684 2.697m8.389 7.032a9.4 9.4 0 0 1-2.722.377m-2.966-.56a8.6 8.6 0 0 1-2.395-1.342m-2.038-2.24a8.7 8.7 0 0 1-1.107-2.524M12.953 3a8.92 8.92 0 0 1 6.392 2.604 9.037 9.037 0 0 1 0 12.791M14.387 8.91h-1.94a1.28 1.28 0 0 0-1.26 1.043 1.29 1.29 0 0 0 .782 1.438l1.97.791a1.284 1.284 0 0 1 .78 1.439 1.29 1.29 0 0 1-1.257 1.042h-1.94m1.433-5.753v-.72m0 7.192v-.719"
  }));
};
export default SvgAutopay;